import * as React from 'react'
import type { ButtonProps as AntdButtonProps } from 'antd'
import { Button as AntdButton } from 'antd'

export interface ButtonProps extends AntdButtonProps {
  className?: string
  loading?: boolean | {
    delay?: number
  }
  ref?: React.MutableRefObject<null>
}

export default function Button({
  type = 'primary',
  className,
  ...props
}: ButtonProps & AntdButtonProps) {
  return (
    <AntdButton
      className={`text-sm uppercase font-bold rounded flex justify-center items-center ${className || ''}`}
      type={type}
      {...props}
    />
  )
}
